document.addEventListener('DOMContentLoaded', () => {
  // Check if we're on a product page
  if (window.location.pathname.includes('/products/')) {
    const breadcrumbLink = document.getElementById('breadcrumb-collection-link');
    
    if (breadcrumbLink) {
      // Get the current URL
      const currentUrl = window.location.href;
      
      // Check if URL contains collection parameter
      if (currentUrl.includes('collection=')) {
        // Extract collection handle from URL
        const urlParams = new URLSearchParams(window.location.search);
        const collectionHandle = urlParams.get('collection');
        
        if (collectionHandle) {
          // Get collections data from the data attributes
          const collections = breadcrumbLink.dataset.collections.split(',');
          const collectionTitles = breadcrumbLink.dataset.collectionTitles.split(',');
          
          // Find the matching collection
          const collectionIndex = collections.indexOf(collectionHandle);
          
          if (collectionIndex !== -1) {
            // Update the breadcrumb link
            const collectionTitle = collectionTitles[collectionIndex];
            const collectionUrl = `/collections/${collectionHandle}`;
            
            breadcrumbLink.textContent = collectionTitle;
            breadcrumbLink.href = collectionUrl;
          }
        }
      }
    }
  }
});
